// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import LocalTime from "local-time"

import "./controllers"
import "./channels"

LocalTime.start()

document.addEventListener("turbo:morph-element", (event) => {
	if (event.target instanceof HTMLTimeElement) {
		LocalTime.process(event.target)
	}
})

function restoreActiveElement() {
	let activeElement = null

	document.addEventListener('turbo:before-render', (e) => {
		if (document.activeElement) {
			activeElement = document.activeElement
		}
	});

	document.addEventListener('turbo:render', (e) => {
		if (!activeElement?.id) return

		const element = document.getElementById(activeElement.id)
		if (!element) return

		element.focus()
		if (activeElement.selectionStart && activeElement.selectionEnd) {
			element.setSelectionRange(
				activeElement.selectionStart,
				activeElement.selectionEnd
			)
		}

		activeElement = null
	});
}

restoreActiveElement()
